module.exports = __webpack_public_path__ + "static/media/promo6.731b4b7d.jpg";